import React from 'react'
import { Booklet } from '../../types/generated.types'
import { formatDate, formatPrice } from './utils/dateFormatter'

interface BookletDetailsProps {
  booklet?: Booklet
  companyCount: number
  couponCount: number
}

const BookletDetails: React.FC<BookletDetailsProps> = ({
  booklet,
  companyCount,
  couponCount
}) => {
  if (!booklet) return null;

  return (
    <>
      <h4 className='mb'>{booklet.title}<br /><span>{booklet.subtitle}</span></h4>

      <div className="booklet-details">
        <div className="detail-row">
          <span className="detail-label">Pris</span>
          <span className="detail-value">{formatPrice(booklet.price)}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Giltigt</span>
          <span className="detail-value">
            {formatDate(booklet.validFrom)}-{formatDate(booklet.validTo)}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Säljs</span>
          <span className="detail-value">
            {formatDate(booklet.buyableFrom)}-{formatDate(booklet.buyableTo)}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Annonsörer</span>
          <span className="detail-value">{companyCount} st</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Kuponger</span>
          <span className="detail-value">{couponCount} st</span>
        </div>
      </div>
    </>
  )
}

export default BookletDetails
